// Import the necessary action types
import * as actions from './actionsTypes';

// Define the initial state
const initialState = {
  isLoadingData: false,
  scheludeTrackingPlannedVacationsEmployee: null,
  scheludeTrackingPlannedVacationsEmployeeFailure: null
};

// Create the reducer function
const ScheduleTrackingPlannedVacationsEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.IS_LOADING_FETCH_SCHEDULE:
      return {
        ...state,
        isLoadingData: action.payload
      };
    case actions.GET_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE:
      return {
        ...state,
        scheludeTrackingPlannedVacationsEmployee: action.payload
      };
    case actions.FAILURE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE:
      return {
        ...state,
        scheludeTrackingPlannedVacationsEmployeeFailure: action.payload
      };
    case actions.UPDATE_SCHEDULE_TRAKING_PLANNED_VACATIONS_EMPLOYEE:
      return {
        ...state,
        scheludeTrackingPlannedVacationsEmployee: action.payload
      };
    default:
      return state;
  }
};

export default ScheduleTrackingPlannedVacationsEmployeeReducer;